import { create } from "zustand";
import { coinHistory, rewardInfo, rewardUserList } from "../api_layer/api";

export const useRewardsInfo = create((set) => ({
  rewardsData: [],
  userListData: [],
  coinHistoryData: [],
  rewardsLoading: false,
  userLoading: false,
  coinLoading: false,
  isError: false,
  fetchRewardInfo: async () => {
    try {
      set({ rewardsLoading: true, error: null });
      const response = await rewardInfo();
      set({ rewardsData: response.data, rewardsLoading: false });
    } catch (error) {
      set({ error: error.message, rewardsLoading: false });
    }
  },
  fetchUserList: async (page) => {
    try {
      set({ userLoading: true, error: null });
      const response = await rewardUserList(page);
      set({ userListData: response.data, userLoading: false });
    } catch (error) {
      set({ error: error.message, userLoading: false });
    }
  },
  fetchCoinHistory: async (userId) => {
    try {
      set({ coinLoading: true, error: null });
      const response = await coinHistory(userId);
      set({ coinHistoryData: response.data, coinLoading: false });
    } catch (error) {
      set({ error: error.message, coinLoading: false });
    }
  },
}));
